import React from 'react';
import styled from 'styled-components';

type ListPricePriceProps = {
  specialPrice: string;
  standardPrice: string;
  savingsLabel?: string;
  hideSalesLanguage?: boolean;
};

export const ListPricePrice = ({
  specialPrice,
  standardPrice,
  savingsLabel,
  hideSalesLanguage = false,
}: ListPricePriceProps): JSX.Element => (
  <Container>
    <PriceColumn>
      <OurPriceLabel>Our price:</OurPriceLabel>
      <OurPriceValue>{specialPrice}</OurPriceValue>
      {!hideSalesLanguage && savingsLabel && <Savings>{savingsLabel}</Savings>}
    </PriceColumn>
    <PriceColumn>
      <OurPriceLabel>List price:</OurPriceLabel>
      <ListValue $hideSalesLanguage={hideSalesLanguage}>{standardPrice}</ListValue>
    </PriceColumn>
  </Container>
);

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 40px;
`;

const PriceColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const OurPriceSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const OurPriceLabel = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 15px;
  letter-spacing: 0.005em;
  text-transform: capitalize;
  color: ${({ theme }) => theme.colors.grey[45]};
`;

export const OurPriceValue = styled.div`
  font-size: 31px;
  font-weight: 600;
  line-height: 34px;
  color: ${({ theme }) => theme.colors.primaryBlack};
`;

const ListValue = styled.div<{ $hideSalesLanguage?: boolean }>`
  font-size: 24px;
  font-weight: 400;
  line-height: 26px;
  text-decoration: ${({ $hideSalesLanguage }) => ($hideSalesLanguage ? 'none' : 'line-through')};
  color: ${({ theme }) => theme.colors.grey[55]};
`;

const Savings = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 0.005em;
  color: ${({ theme }) => theme.colors.red[55]};
`;
